export const formItemLayout = {
  wrapperCol: {
    xs: { span: 18, offset: 0 },
    sm: { span: 18, offset: 3 },
  },
  labelCol: {
    xs: { span: 18, offset: 0 },
    sm: { span: 18, offset: 3 },
  },
};
